import React from 'react';

const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const WeekdaySelector = ({ selectedDays = '', onChange, error }) => {
    const normalizeSelected = (val) => {
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') return val.split(',').map(d => d.trim()).filter(Boolean);
        return [];
    };

    const selectedArray = normalizeSelected(selectedDays);

    const toggleDay = (day, checked) => {
        let updatedDays = checked
            ? [...selectedArray, day]
            : selectedArray.filter(d => d !== day);
        onChange(updatedDays);
    };

    return (
        <div className="form-group" style={{ marginBottom: 10 }}>
            <label className="pd10botbuilder">
                Days of Week
            </label>
            <div className="row">
                {WEEKDAYS.map((day, index) => (
                    <div key={day} className="col-md-2 mb-2">
                        <div className="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`day_${index}`}
                                checked={selectedArray.includes(day)}
                                onChange={(e) => toggleDay(day, e.target.checked)}
                                style={{ accentColor: 'rgb(15, 98, 254)' }}
                            />
                            <label className="custom-control-label" htmlFor={`day_${index}`} style={{ color: '#495057', fontWeight: '500' }}>
                                {day}
                            </label>
                        </div>
                    </div>
                ))}
                {error && (
                    <div className="col-12">
                        <div className="error invalid-feedback d-block" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
                            {error}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WeekdaySelector;
